<div class="button-align" >
    <button #new mat-raised-button class="new-color" style="Padding-right: 20px;  background-color: #39a9f3; color: white;" (click)="newItem()" >
        <mat-icon style="margin-right: 3px;margin-bottom: 1px;font-size: 22px;">add_circle</mat-icon> Add New</button>
</div>